const rawBase = (import.meta.env.VITE_API_BASE as string | undefined) ?? '';

export const API_BASE = (rawBase && rawBase.trim() ? rawBase.trim() : 'https://api.ionicerrrrscode.com').replace(/\/$/, '');
